<template>
  <div class="gauge__wrapper" :style="`width: ${size}px; height: ${(size / 2) + 30}px`">
    <div class="gauge" :style="`width: ${(size + 1) / 2}px; height: ${size}px`">
      <radial-progress-bar
        class="gauge__element"
        :diameter="size"
        :completed-steps="completed"
        :strokeWidth="trackWidth"
        :total-steps="200"
        :animateSpeed="400"
        stopColor="#4DAA57"
        startColor="#4DAA57"
        innerStrokeColor="#f2f2f2"
      >
        <div class="gauge__content">
          <slot v-if="!label && !text"></slot>
          <div v-else>
            <div class="gauge__text" :style="`font-size: ${textSize}; top: ${textTopPos}`">{{ text }}</div>
          </div>
        </div>
      </radial-progress-bar>
    </div>
    <div class="gauge__label">{{ label }}</div>
  </div>
</template>

<script>
export default {
  props: {
    completed: {
      type: Number,
      default: 0
    },
    size: {
      type: Number,
      default: 100
    },
    maskColor: {
      type: String,
      default: 'white'
    },
    trackWidth: {
      type: Number,
      default: 7
    },
    text: {
      type: String
    },
    textSize: {
      type: String,
      default: '1.6em'
    },
    textTopPos: {
      type: String,
      default: '20%'
    },
    label: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.gauge {
  top: calc(-50% + 15px);
  left: 25%;
  position: relative;
  transform: rotate(-90deg);
  overflow: hidden;

  &__element {
    position: absolute;
    left: calc(-100% + 4px);
  }

  &__content {
    position: relative;
    transform: rotate(90deg);
    padding-bottom: 15px;
    width: 90%;
    height: 80%;
    text-align: center;
  }

  &__wrapper {
    position: relative;
  }

  &__text {
    position: absolute;
    width: 100%;
    text-align: center;
    font-family: "Work Sans";
    font-weight: 700;
  }

  &__label {
    width: 100%;
    position: absolute;
    bottom: 8px;
    text-align: center;
    font-weight: 700;
  }
}
</style>

